import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { OwnersDisplayGridRowDataFragmentGql } from './OwnersDisplayGridRowFragmentGql';

// Should fetch same nodes as DatasourceDownstreamOwnerIdsQuery
export const DatasourceDownstreamOwnersQueryGql: DocumentNode = gql`
query DatasourceDownstreamOwnersQuery($vizportalUrlId: String!, $first: Int!, $offset: Int!, $orderBy: TableauUserSortOrder!) {
  publishedDatasources(filter: { vizportalUrlId: $vizportalUrlId }) {
    downstreamOwnersConnection(first: $first, offset: $offset, orderBy: $orderBy) {
      totalCount
      nodes {
        ...OwnersDisplayGridRowDataFragment
      }
    }
  }
}
${OwnersDisplayGridRowDataFragmentGql}
`;
